import RcTabs from "../../_rc-tabs-5.9.2";
import React, { cloneElement } from "react";
import classNames from "classnames";
import Icon from "../icon";
import isEmpty from "lodash/isEmpty";
import uniqueId from "lodash/uniqueId";
import remove from "lodash/remove";
import middleware from "../../middleware";

class Tabs extends React.Component {
  static TabPane = RcTabs.TabPane;

  static defaultProps = {
    prefixCls: "ant-tabs",
    animation: "slide-horizontal",
    type: "line", // or 'card' 'editable-card'
    onChange() {},
    onEdit() {},
    hideAdd: false
  };

  constructor(props) {
    super(props);
    this.index = uniqueId("tabKey");
  }

  componentWillUnmount() {
    remove(window.tabKeys, o => o.slice(0, o.indexOf("_")) === this.index);
  }

  createNewTab = targetKey => {
    this.props.onEdit(targetKey, "add");
  };

  removeTab = (targetKey, e) => {
    e.stopPropagation();
    if (!targetKey) {
      return;
    }
    this.props.onEdit(targetKey, "remove");
  };

  handleChange = activeKey => {
    this.props.onChange(activeKey);
  };

  getActiceName = () => {
    const { datas = [], activeKey, keyParam } = this.props;
    const _datas = datas.slice();
    let name = "";
    Array.isArray(_datas) &&
      !isEmpty(_datas) &&
      _datas.forEach(v => {
        v[keyParam] == activeKey && (name = v.title);
      });
    return name;
  };

  render() {
    let {
      prefixCls,
      size,
      tabPosition,
      animation,
      type,
      children,
      tabBarExtraContent,
      hideAdd,
      activeKey
    } = this.props;
    let className = classNames({
      [this.props.className]: !!this.props.className,
      [`${prefixCls}-mini`]: size === "small" || size === "mini",
      [`${prefixCls}-vertical`]:
        tabPosition === "left" || tabPosition === "right",
      [`${prefixCls}-card`]: type.indexOf("card") >= 0,
      [`${prefixCls}-${type}`]: true
    });
    if (
      tabPosition === "left" ||
      tabPosition === "right" ||
      type.indexOf("card") >= 0
    ) {
      animation = null;
    }
    // only card type tabs can be added and closed
    let childrenWithCross;
    if (type === "editable-card") {
      childrenWithCross = [];
      React.Children.forEach(children, (child, index) => {
        childrenWithCross.push(
          cloneElement(child, {
            tab: (
              <div>
                {child.props.tab}
                <Icon
                  ecId={`${this.props.ecId}_Icon@n8wd4n`}
                  type="cross"
                  onClick={e => this.removeTab(child.key, e)}
                />
              </div>
            ),
            key: child.key || index
          })
        );
      });
      // Add new tab handler
      if (!hideAdd) {
        tabBarExtraContent = (
          <span>
            <Icon
              ecId={`${this.props.ecId}_Icon@w421dh`}
              type="plus"
              className={`${prefixCls}-new-tab`}
              onClick={this.createNewTab}
            />
            {tabBarExtraContent}
          </span>
        );
      }
    }

    tabBarExtraContent = tabBarExtraContent ? (
      <div className={`${prefixCls}-extra-content`}>{tabBarExtraContent}</div>
    ) : null;

    const name = this.getActiceName();
    const res = this.index + "_key:" + activeKey + "_name:" + name;
    if (Array.isArray(window.tabKeys)) {
      let index = -1;
      window.tabKeys.forEach((v, l) => {
        v.slice(0, v.indexOf("_")) === this.index && (index = l);
      });
      index !== -1 ? (window.tabKeys[index] = res) : window.tabKeys.push(res);
    } else {
      window.tabKeys = [res];
    }
    return (
      <RcTabs
        {...this.props}
        ecId={`${this.props.ecId}_RcTabs@pnkieg`}
        className={className}
        tabBarExtraContent={tabBarExtraContent}
        onChange={this.handleChange}
        animation={animation}
      >
        {childrenWithCross || children}
      </RcTabs>
    );
  }
}

const Com = middleware(Tabs, "Tabs");

export default Com;



// WEBPACK FOOTER //
// ./_antd1.11.2/tabs/index.jsx